// extracted by mini-css-extract-plugin
module.exports = {"container":"application_wrapper_container__2_SGP","watermark":"application_wrapper_watermark__t_2xH","avatar":"application_wrapper_avatar__2_75H"};